import Loader from '@/components/Loader/Loader';
import DataTablePopupCard from './DataTableStatusCard';

const DataTablePopupData = ({ tableData, isLoading }: any) => {
  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center h-[60vh]">
          <Loader size="lg" color="primary" />
        </div>
      ) : (
        <div className="flex flex-col min-h-screen bg-white">
          {/* Main content */}
          <main className="flex-1 ">
            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <DataTablePopupCard
                title={
                  tableData?.cardsData?.totalEnrollments ? 'Total Enrollments' : 'Total Schools'
                }
                value={tableData?.cardsData?.totalSchools || tableData?.cardsData?.totalEnrollments}
              />
              <DataTablePopupCard title="Level" value={tableData?.cardsData?.level} />
              <DataTablePopupCard title="Year" value={tableData?.cardsData?.year} />
            </div>

            {/* Search and Table */}
            <div className="bg-white rounded-lg shadow overflow-hidden">
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-[#E5EAFE]">
                    <tr>
                      <th className="px-6 py-3 text-left text-sm font-semibold text-ds-gray-600 uppercase tracking-wider">
                        #
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-semibold text-ds-gray-600 uppercase tracking-wider">
                        Campus Name
                      </th>
                      <th className="px-6 py-3 text-left text-sm font-semibold text-ds-gray-600 uppercase tracking-wider">
                        {tableData?.cardsData?.totalEnrollments ? 'Enrollments' : 'School Number'}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {tableData?.tableData?.map((school: any, index: any) => (
                      <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {school.campusName}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {school.SchoolNumber ?? school.enrollments}
                        </td>
                      </tr>
                    ))}
                    {tableData?.tableData?.length === 0 && (
                      <tr>
                        <td colSpan={3} className="px-6 py-4 text-center text-sm text-gray-500">
                          No schools found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination placeholder */}
              <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm text-gray-700">
                      Showing <span className="font-medium">1</span> to{' '}
                      <span className="font-medium">{tableData?.tableData?.length}</span> of{' '}
                      <span className="font-medium">{tableData?.tableData?.length}</span> results
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      )}
    </>
  );
};

export default DataTablePopupData;
